import { qx_eAuthProvider_enum } from '@/graphql/types';

export const PLACE_DEFAULT_ICON = 'location-dot';

export const AUTH_PROVIDER_LABELS: Record<qx_eAuthProvider_enum, string> = {
  [qx_eAuthProvider_enum.entra]: 'Microsoft Entra',
  [qx_eAuthProvider_enum.ldap]: 'LDAP'
};
